export class OrderRateReasonMiniEntity {
  id?: number
  name?: string | null
  minRate?: number
  maxRate?: number
  channelId?: number
  channelName?: string | null
}
